export const ENTRADA_STEP_KEYS = [
  'handover',
  'montarEquipe',
  'grupoWhatsapp',
  'onboarding',
] as const

export type EntradaStepKey = (typeof ENTRADA_STEP_KEYS)[number]

/** Atualizadas pelo kanban comercial — não aparecem no checklist manual. */
export const AUTOMATIC_ENTRADA_STEP_KEYS = ['handover', 'grupoWhatsapp'] as const

export type AutomaticEntradaStepKey = (typeof AUTOMATIC_ENTRADA_STEP_KEYS)[number]

/** Checklist operacional do gestor. */
export const MANUAL_ENTRADA_STEP_KEYS = ['montarEquipe', 'onboarding'] as const

export type ManualEntradaStepKey = (typeof MANUAL_ENTRADA_STEP_KEYS)[number]

export type EntradaStepState = {
  done: boolean
  doneAt: string | null
  note: string | null
}

export type EntradaSteps = Record<EntradaStepKey, EntradaStepState>

export const ENTRADA_STEP_LABELS: Record<EntradaStepKey, string> = {
  handover: 'Handover comercial',
  montarEquipe: 'Montar equipe',
  grupoWhatsapp: 'Criar grupo no WhatsApp',
  onboarding: 'Onboarding do cliente',
}

export const ENTRADA_STEP_DESCRIPTIONS: Record<EntradaStepKey, string> = {
  handover: 'Receber contexto do closer, escopo contratado e alinhamento inicial.',
  montarEquipe: 'Definir profissionais PJ e papéis para atender o cliente.',
  grupoWhatsapp: 'Criar grupo com cliente e equipe de entrega.',
  onboarding: 'Conduzir kickoff e primeiros passos operacionais do serviço.',
}

export type EntradaStatus = 'EM_ANDAMENTO' | 'CONCLUIDO'
